module.exports = __webpack_public_path__ + "static/img/jd3.6608865.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jd3.jpg
// module id = Km69
// module chunks = 1